export function getProfileImage(user) {
  try {
    return user.get("rsProfile").get("image").url();
  } catch (error) {
    return null;
  }
}
